export default {
  settingText: '列设置',
  setting: {
    /**
     * 列展示
     */
    displayColumn: '列展示',
    /**
     * 序号列
     */
    displayIndex: '序号列',
    /**
     * 勾选列
     */
    displaySelect: '勾选列',
    /**
     * 重置按钮
     */
    resetButton: '重置',
    /**
     * 固定
     */
    fixedLeft: '固定到左侧',
    fixedRight: '固定到右侧',
  },
  /**
   * 密度
   */
  density: '密度',
  /**
   * 密度设置
   */
  densityOptions: {
    small: '小',
    medium: '中',
    large: '大',
  },
  /**
   * 刷新数据按钮
   */
  refreshButton: '刷新',
  table: {
    index: '#',
  },
};
